<template>
    <div class="pager">
        <nav aria-label="Page navigation">
            <ul class="pagination">
                <li>
                    <span class="pageInfo">共{{allPage}}条数据</span>
                </li>
                <li>
                    <a href="javascript:void(0)" aria-label="Previous" v-show="current != 1" @click="current--&&jumpcurrent-- && goto(current)">
                        <span aria-hidden="true">上一页</span>
                    </a>
                </li>
                <li :class="{'active':current == index}" v-for="index in pages" :key="index">
                    <a href="javascript:void(0)" @click="goto(index)">{{index}}</a>
                </li>
                <li>
                    <a href="javascript:void(0)" aria-label="Next" v-show="total != current && total != 0 " @click="current++ && jumpcurrent ++ && goto(current)">
                        <span aria-hidden="true">下一页</span>
                    </a>
                </li>
                <li class="goto-page">
                    <span>第</span>
                    <input class="jumpPage" type="text" v-model="jumpcurrent" />
                    <span>页</span>
                </li>
                <li>
                    <a href="javascript:void(0)" style="margin-left:10px;background:#4CCE9D;color:#fff;border-color:#4CCE9D;" @click="goto(jumpcurrent)">跳转</a>
                </li>
            </ul>
        </nav>
    </div>
</template>
<script>
export default {
    name: 'pager',
    props: ['total', 'allPage'],
    data() {
        return {
            jumpcurrent: 1,//跳转页计数
            current: 1,//显示页计数
            currentnum: 5,//导航总显示个数
        }
    },
    watch: {
        // current: function (old, newVal) {
        // }
    },
    computed: {
        pages: function () {
            var pag = [];
            
            if (this.current < this.currentnum) { //如果当前的激活的项 小于要显示的条数
                //总页数和要显示的条数那个大就显示多少条
                var i = Math.min(this.currentnum, this.total);
                while (i) {
                    pag.unshift(i--);
                }
            } else { //当前页数大于显示页数了
                var middle = this.current - Math.floor(this.currentnum / 2);//从哪里开始
                var e = this.currentnum;
                if (middle > (this.total - this.currentnum)) {
                    middle = (this.total - this.currentnum) + 1
                }
                while (e--) {
                    pag.push(middle++);
                }
            }
            return pag
        }
    },
    methods: {
        goto: function (index) {
            if (this.jumpcurrent > this.total) {
                this.jumpcurrent = this.current;
                // Message({
                //     title: "错误",
                //     message: '超出最大页码',
                //     type: 'error',
                //     duration: 5 * 1000
                // })
                return;
            } else {
                this.jumpcurrent = index;
                this.current = index;
            }
            this.$emit("change", index);
        }
    }
}
</script>
<style scoped>
.pager{
    display: block;
    width: 100%;
    padding: 20px 20px;
}
.pagination {
    margin: 0;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    height: 45px;
}
.pagination > li{
    line-height: 30px;
    font-size: 13px;
    color: #606266;
}
.goto-page{
    display: -webkit-flex;
    display: flex;
    margin-left: 20px
}
.goto-page input{
    border: 1px solid #dedede;
    margin: 0 5px;
    min-width: 40px;
}
.pagination > li > a {
    background: none;
    /*background:rgba(211,220,230,.5);*/
    color: #606266;
    padding: 2px 10px;
    margin: 0 2px;
    border-color: #99a0a8;
    background-color: #f4f4f5;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    min-width: 35px;
    display: block;
    text-align: center;
}
/*.active {
background-color: #337AB7;
color:#fff;
}*/
.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
    background-color: #4CCE9D;
    color: #f8f8f8;
    border-color: #4CCE9D;
}
.jumpPage {
    width: 25px;
    text-align: center;
    background: none;
    border: none;
    padding: 2px 0;
}
.pageInfo {
    padding: 2px 10px;
    background: none;
    border: none;
    color: #999999;
}
</style>